import * as Sentry from '@sentry/browser';

export const SUBSCRIPTION_URL = '#/subscription/billing';
export const ALLOWED_SENTRY_MICROS = [SUBSCRIPTION_URL];
export const MICROS_SUBSCRIPTION_TAG = 'subscription';
export const MICROS_TAG = 'micros';

export default function configureSentry() {
    if (process.env.SENTRY_PROJECT_URL) {
        Sentry.init({
            dsn: process.env.SENTRY_PROJECT_URL,
            environment: process.env.ENVIRONMENT,
        });
    }
}
